module.exports = __webpack_public_path__ + "glyphicons-social-regular.b8cd97250d7a149a69ca.woff";


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/css/fonts/glyphicons.social.pro/glyphicons-social-regular.woff
// module id = ../../../../../src/assets/css/fonts/glyphicons.social.pro/glyphicons-social-regular.woff
// module chunks = 2